var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.926,
    height: 10.264,
    viewBox: "0 0 16.926 10.264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "email-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.926,
    height: 10.264,
    transform: "translate(0 0)",
    fill: "current"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#email-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.971,0H1.955A1.957,1.957,0,0,0,0,1.955V8.309a1.958,1.958,0,0,0,1.955,1.956H14.971a1.958,1.958,0,0,0,1.955-1.956V1.955A1.957,1.957,0,0,0,14.971,0m0,1a.875.875,0,0,1,.169.035l-6.1,3.64a1.121,1.121,0,0,1-1.151,0l-6.1-3.641A.933.933,0,0,1,1.955,1Zm.955,7.309a.957.957,0,0,1-.955.956H1.955A.957.957,0,0,1,1,8.309V1.955a.926.926,0,0,1,.041-.2L7.375,5.534a2.123,2.123,0,0,0,2.176,0l6.334-3.78a.908.908,0,0,1,.041.2Z",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.ae18aa1678a5b7a9781d921b6c499c3f.svg";
export { ForwardRef as ReactComponent };